function f2170(p18205) {
  if (!p18205 || p18205 < 1) {
    throw new Error("BitMatrix size must be defined and greater than 0");
  }
  this.size = p18205;
  this.data = new Uint8Array(p18205 * p18205);
  this.reservedBit = new Uint8Array(p18205 * p18205);
}
f2170.prototype.set = function (p18206, p18207, p18208, p18209) {
  const v14017 = p18206 * this.size + p18207;
  this.data[v14017] = p18208;
  if (p18209) {
    this.reservedBit[v14017] = true;
  }
};
f2170.prototype.get = function (p18210, p18211) {
  return this.data[p18210 * this.size + p18211];
};
f2170.prototype.xor = function (p18212, p18213, p18214) {
  this.data[p18212 * this.size + p18213] ^= p18214;
};
f2170.prototype.isReserved = function (p18215, p18216) {
  return this.reservedBit[p18215 * this.size + p18216];
};
module.exports = f2170;